<app-guest-auth-main-layout>
  <ng-template>
    <p class="text-2xl w-full font-bold text-center text-primary-500">{{"Activate Your Account" |concat|translate }}</p>
    <form (ngSubmit)="submitForm(formData?.value)" [formGroup]="formData" autocomplete="off" novalidate class="mt-4">
      <mat-form-field appearance="outline" class="material-form w-full rounded-3xl">
        <mat-label>{{"Password" |concat|translate }}</mat-label>
        <input  [type]="showPassword ? 'text' : 'password'" matInput formControlName="password" placeholder='{{"Password" |concat|translate }}'>
        <div
          (click)="togglePasswordVisibility()"
          class="position-relative mr-2"
          matSuffix
        >
          <mat-icon
            [svgIcon]="showPassword ? 'view_off' : 'view'"
            class="faded right-1 hover-show"
          ></mat-icon>
        </div>
        <mat-error *ngIf="formData.get('password').hasError('passwordPolicy')">
         {{" Password must be at least 8 characters long, contain uppercase and lowercase letters, a number, and a special character." |concat|translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field
        appearance="outline" class="material-form mt-4 w-full rounded-3xl">
        <mat-label>{{"Confirm Password" |concat|translate }}</mat-label>
        <input [type]="showPassword1 ? 'text' : 'password'" matInput placeholder='{{"Confirm Password" |concat|translate }}' formControlName="confirmPassword">
        <div
          (click)="togglePasswordVisibility1()" class="position-relative mr-2" matSuffix>
          <mat-icon
            [svgIcon]="showPassword1 ? 'view_off' : 'view'"
            class="faded right-1 hover-show">
          </mat-icon>
        </div>
        <mat-error *ngIf="formData.get('confirmPassword').value !== formData.get('password').value">
         {{"Passwords do not match" |concat|translate }}
        </mat-error>
      </mat-form-field>
      <div class="w-full">
        <button type="submit" mat-raised-button color="primary" class="w-full">
          {{"Activate Account" |concat|translate }}
        </button>
      </div>
    </form>
  </ng-template>
  </app-guest-auth-main-layout>
